import RouterSection from '@/Layout/components/RouterSection.vue';
import { checkAuthorization } from '@/router/NavigationGuards';

export default {
	path: '/panchok',
	name: 'panchok',
	component: RouterSection,
	mode: 'history',
	children: [
		{
			// 판촉 시안 선택
			path: 'orders/:orderNumber',
			name: 'orderDetail',
			component: () => import('@/views/panchok/orders/orderDetail'),
			beforeEnter: checkAuthorization,
		},
		{
			// 판촉 시안 확인
			path: 'orders',
			name: 'orders',
			component: () => import('@/views/panchok/orders'),
			beforeEnter: checkAuthorization,
		},
	],
};
